import Component from '../core/Component'

const ACTIVE = 'is-active'

export default class Map extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            items: [],
            toggles: []
        }
    }

    prepare() {
        this.ref.toggles.forEach(toggle => {
            toggle.addEventListener('mouseenter', ::this.handleEnter)
            toggle.addEventListener('mouseleave', ::this.handleEnter)
        })
        this.ref.items.forEach((item, index) => this.hide(index, true))
    }

    handleEnter(event) {
        console.log("enter");
        event.preventDefault()
        const index = this.ref.toggles.indexOf(event.currentTarget)
        this.toggle(index)
    }

    toggle(itemIndex) {
        const item = this.ref.items[itemIndex]

        if (item.classList.contains(ACTIVE)) {
            this.hide(itemIndex)
        } else {
            this.show(itemIndex)
        }
    }

    show(itemIndex) {

        const item = this.ref.items[itemIndex]

        setTimeout(() => {
            item.classList.add(ACTIVE)
            this.ref.items.forEach((item, index) => {
                if (index !== itemIndex) {
                    this.hide(index)
                }
            })
        }, 200)
    }

    hide(itemIndex) {
        if (this.ref.items[itemIndex].classList.contains(ACTIVE) ) {
            this.ref.items[itemIndex].classList.remove(ACTIVE)
        }
    }
}